import Vue from 'vue';
import Vuex from 'vuex';
import userInfoModule from './userInfoModule';
import scApi from '../api/scApi';
import bookingDetailsModule from './bookingDetailsModule';

Vue.use(Vuex);

const eligibility = {
  state: {
    BeginDate: '',
    EndDate: '',
    ResponseID: '',
  },
  mutations: {
    beginDate(state, payload) {
      state.BeginDate = payload.value;
    },
    endDate(state, payload) {
      state.EndDate = payload.value;
    },
    responseID(state, payload) {
      state.ResponseID = payload.value;
    },
  },
  actions: {
    beginDate(context, payload) {
      context.commit('beginDate', payload);
    },
    endDate(context, payload) {
      context.commit('endDate', payload);
    },
    responseID(context, payload) {
      context.commit('responseID', payload);
    },
  },
  getters: {
    beginDate(state) {
      return state.BeginDate;
    },
    endDate(state) {
      return state.EndDate;
    },
    responseID(state) {
      return state.ResponseID;
    },
  },
};

const siteData = {
  state: {
    ServiceTypes: [],
    Cities: [],
    SessionTimeout: '',
    EarlyMinutes: '',
    LateMinutes: '',
  },
  mutations: {
    serviceTypes(state, payload) {
      state.ServiceTypes = payload;
    },
    cities(state, payload) {
      state.Cities = payload;
    },
    sessionTimeout(state, payload) {
      state.SessionTimeout = payload;
    },
    earlyMinutes(state, payload) {
      state.EarlyMinutes = payload;
    },
    lateMinutes(state, payload) {
      state.LateMinutes = payload;
    },
  },
  actions: {
    serviceTypes(context, payload) {
      context.commit('serviceTypes', payload);
    },
    cities(context, payload) {
      context.commit('cities', payload);
    },
    sessionTimeout(context, payload) {
      context.commit('sessionTimeout', payload);
    },
    earlyMinutes(context, payload) {
      context.commit('earlyMinutes', payload);
    },
    lateMinutes(context, payload) {
      context.commit('lateMinutes', payload);
    },
    async getSiteData(context) {
      try {
        const data = await scApi.GetSiteData();
        context.commit('serviceTypes', data.ServiceTypes);
        context.commit('cities', data.Cities);
        context.commit('sessionTimeout', data.SiteConfigSettings.SessionTimeout);
        context.commit('earlyMinutes', data.SiteConfigSettings.EarlyMinutes);
        context.commit('lateMinutes', data.SiteConfigSettings.LateMinutes);
        console.log(data.SiteConfigSettings);
      } catch (error) {
        console.log(error);
      }
    },
  },
  getters: {
    serviceTypes(state) {
      // console.log(state.ServiceTypes);
      return state.ServiceTypes;
    },
    cities(state) {
      return state.Cities;
    },
    sessionTimeout(state) {
      return state.SessionTimeout;
    },
    earlyMinutes(state) {
      return state.EarlyMinutes;
    },
    lateMinutes(state) {
      return state.LateMinutes;
    },
  },
};

const existingBooking = {
  state: {
    ExistingAppointment: false,
    IsNewServiceType: false,
    Booking: [],
  },
  mutations: {
    existingAppointment(state, payload) {
      state.ExistingAppointment = payload.value;
    },
    isNewServiceType(state, payload) {
      state.IsNewServiceType = payload.value;
    },
    booking(state, payload) {
      state.Booking = payload.value;
    },
  },
  actions: {
    existingAppointment(context, payload) {
      context.commit('existingAppointment', payload);
    },
    isNewServiceType(context, payload) {
      context.commit('isNewServiceType', payload);
    },
    booking(context, payload) {
      context.commit('booking', payload);
    },
  },
  getters: {
    existingAppointment(state) {
      return state.ExistingAppointment;
    },
    isNewServiceType(state) {
      return state.IsNewServiceType;
    },
    booking(state) {
      return state.Booking;
    },
  },
};

const availableLocations = {
  state: {
    AvailableLocation: [],
    SelectedLocation: '',
  },
  mutations: {
    availableLocation(state, payload) {
      state.AvailableLocation = payload.value;
    },
    selectedLocation(state, payload) {
      state.SelectedLocation = payload.value;
    },
  },
  actions: {
    availableLocation(context, payload) {
      context.commit('availableLocation', payload);
    },
    selectedLocation(context, payload) {
      context.commit('selectedLocation', payload);
    },
  },
  getters: {
    availableLocation(state) {
      return state.AvailableLocation;
    },
    selectedLocation(state) {
      return state.SelectedLocation;
    },
  },
};

const customerDetailsPage = {
  state: {
    DayOfWeek: 0,
    ZipCodeValue: '',
    CityTown: '',
    TextMsgCheckBox: false,
  },
  mutations: {
    dayOfWeek(state, payload) {
      state.DayOfWeek = payload.value;
    },
    zipCodeValue(state, payload) {
      state.ZipCodeValue = payload.value;
    },
    cityTown(state, payload) {
      state.CityTown = payload.value;
    },
    textMsgCheckBox(state, payload) {
      state.TextMsgCheckBox = payload.value;
    },
  },
  actions: {
    dayOfWeek(context, payload) {
      context.commit('dayOfWeek', payload);
    },
    zipCodeValue(context, payload) {
      context.commit('zipCodeValue', payload);
    },
    cityTown(context, payload) {
      context.commit('cityTown', payload);
    },
    textMsgCheckBox(context, payload) {
      context.commit('textMsgCheckBox', payload);
    },
  },
  getters: {
    dayOfWeek(state) {
      return state.DayOfWeek;
    },
    zipCodeValue(state) {
      return state.ZipCodeValue;
    },
    cityTown(state) {
      return state.CityTown;
    },
    textMsgCheckBox(state) {
      return state.TextMsgCheckBox;
    },
  },
};

const sessionInfo = {
  state: {
    IsLogIn: false,
  },
  mutations: {
    isLogIn(state, payload) {
      state.IsLogIn = payload.value;
    },
  },
  actions: {
    isLogIn(context, payload) {
      context.commit('isLogIn', payload);
    },
  },
  getters: {
    isLogIn(state) {
      return state.IsLogIn;
    },
  },
};

const store = new Vuex.Store({
  modules: {
    userInfo: userInfoModule,
    eligibility,
    siteData,
    existingBooking,
    availableLocations,
    customerDetailsPage,
    bookingDetails: bookingDetailsModule,
    sessionInfo,
  },
});
export default store;
